export enum UserRole {
    SuperUser = 'super-user',
    MerchantAdmin = 'merchant-admin',
    Admin = 'admin',
    Support = 'support',
    Viewer = 'viewer',
}
